import React from 'react'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { VariableVCards } from '../VariableVCards';
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import '../vcard.css'
import InputCustom from '../../../components/elements/InputCustom';
import TextAreaCustom from '../../../components/elements/TextAreaCustom';
import imgg from '../../../assets/images/kharef.png'
import imgg1 from '../../../assets/images/ahlam.jfif'

function AddVCard() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setStateCustom, setLoad } = VariableVCards();
    const handleFieldChange = (name, value) => {
        setStateCustom(name, value)
    }
    return (
        <main>
            <div className='div_table margin_main shadow_main' >
                <div className='new-vcard' >
                    <h3>{translate('add_vcard')}</h3>
                    <div className='d-flex jc-space-between' style={{ marginTop: "10px" }} >
                        <div style={{ width: "100%" }} >
                            <InputCustom
                                label='url_alias'
                                iconType='link'
                                type='text'
                                onChange={(e) => setStateCustom('url_alias', e.target.value)}
                            />
                        </div>
                        <div style={{ width: "49%" }} >
                            <InputCustom
                                label='vcard_name'
                                iconType='vcard'
                                type='text'
                                onChange={(e) => setStateCustom('vcard_name', e.target.value)}
                            />
                        </div>
                        <div style={{ width: "49%" }} >
                            <InputCustom
                                label='occupation'
                                iconType='industry'
                                type='text'
                                onChange={(e) => setStateCustom('occupation', e.target.value)}
                            />
                        </div>
                        <div style={{ width: "49%" }}>
                            <TextAreaCustom
                                vcard
                                label='description'
                                value={state.description}
                                onChange={(e) => setStateCustom('description', e.target.value)}
                                nameClass='textarea-gen'
                            />
                        </div>
                        <div style={{ width: "24%" }} >
                            <InputCustom
                                label='profile_image'
                                iconType='file'
                                type='file'
                                onChange={handleFieldChange}
                                typeFileOne
                                name={'profile_image'}
                            />
                            {console.log(state?.profile_image)}
                            {/*
                                state?.profile_image && (
                                    <img src={`${process.env.REACT_APP_BASE_URL_IMAGES}${state?.profile_image}`} />
                                )
                            */}
                            <img style={{objectFit: "contain"}} width={'90%'} height={'140px'} src={imgg} />

                        </div>
                        <div style={{ width: "24%" }} >
                            <InputCustom
                                label='cover_image'
                                iconType='file'
                                type='file'
                                onChange={handleFieldChange}
                                typeFileOne
                                name={'cover_image'}
                            />
                            {/*
                                state?.cover_image && (
                                    <img src={`${process.env.REACT_APP_BASE_URL_IMAGES}${state?.cover_image}`} />
                                )
                            */}
                            <img style={{objectFit: "contain"}} width={'90%'} height={'140px'} src={imgg1} />
                        </div>
                    </div>
                    <br></br><br></br>
                    <button onClick={()=>{}} className='btn_top_table'>{translate('save')}</button>
                    <br></br>
                </div>
            </div>
        </main>
    )
}

export default AddVCard